import { TestResultDropdownOptions, TestAsFoundResultValue } from '../../../TestResultComponent/TestResult.formulas';
import { FailedComponent } from '../../../../Sections.constants';

export const valvePlaceHolder = 'Select Valve Position';
export const otherPartSpecify = 'Other part (specify)';
export const failedComponentsOptions = [
    { name: 'Valve', value: 'Valve' },
    { name: 'Actuator', value: 'Actuator' },
    { name: 'Solenoid', value: 'Solenoid' },
    { name: 'I/P positioner', value: 'I/P positioner' },
    { name: 'Position transmitter', value: 'Position transmitter' },
    { name: 'Limit switch', value: 'Limit switch' },
    { name: 'Pilot valve', value: 'Pilot valve' },
    { name: 'Quick exhaust valve', value: 'Quick exhaust valve' },
    { name: 'Check valve', value: 'Check valve' },
    { name: 'Relief valve', value: 'Relief valve' },
    { name: 'Volume booster', value: 'Volume booster' },
    { name: 'Flow regulator', value: 'Flow regulator' },
    { name: 'Filter regulator', value: 'Filter regulator' },
    { name: 'Dust excluder', value: 'Dust excluder' },
    { name: otherPartSpecify, value: otherPartSpecify },
    { name: 'Unknown', value: 'Unknown' }
].sort((a, b) => {
    if (a.name === 'Unknown') return 1;
    if (b.name === 'Unknown') return -1;
    if (a.name === otherPartSpecify) return 1;
    if (b.name === otherPartSpecify) return -1;
    return a.name.localeCompare(b.name);
});
const isFailedDisabled = (formData) => (formData.F85TestResult !== 'Fail' || formData.F85TestResult !== 'FailWithCorrectiveNotification');
const includeP716 = (formName) => formName.includes('P7-16');
const isFailResult = (formData) => formData.F85TestResult === 'Fail' || formData.F85TestResult === 'FailWithCorrectiveNotification';
const failedComponentsHeight = (formData) => (isFailResult(formData) ? '1.7rem' : '1.25rem');
const valvePositionOptions = [
    { name: valvePlaceHolder, value: '' },
    { name: 'Open', value: 'Open' },
    { name: 'Closed', value: 'Closed' },
    { name: 'Intermediate', value: 'Intermediate' }
];
export const ValveSizeSectionDataP716 = (formName, formData) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'F343PhysicalValvePositionAfterTest',
                    label: 'Physical Valve Position After Test',
                    value: formData.F343PhysicalValvePositionAfterTest,
                    isDropDown: true,
                    placeholder: valvePlaceHolder,
                    options: valvePositionOptions,
                    xs: 6,
                    type: 'number',
                    maxLength: '10',
                    isRequired: true,
                    width: '56.4%',
                    labelWidth: '43.2%',
                    marginTop: '20px',
                    height: '1.7rem'
                },
                {
                    key: 'F347HmivalvePositionAfterTestLabel',
                    label: 'HMI Valve Position After Test',
                    xs: 2,
                    fontWeight: '600',
                    isLabel: true,
                    padding: '20px 0 0 0',
                    labelWidth: '96%',
                    textAlign: 'end',
                    fontSize: '9pt',
                },
                {
                    key: 'F347HmivalvePositionAfterTest',
                    value: formData.F347HmivalvePositionAfterTest,
                    isDropDown: true,
                    placeholder: valvePlaceHolder,
                    options: valvePositionOptions,
                    xs: 4,
                    type: 'number',
                    maxLength: '10',
                    labelWidth: '0',
                    width: '100%',
                    textAlign: 'center',
                    marginTop: '20px',
                    height: '1.7rem'
                },
            ]
        },
        {
            key: 2,
            fields: [
                ...(includeP716(formName) ? [{
                    key: 'F1073NumberOfAttempts',
                    label: 'Number Of Attempts',
                    value: formData.F1073NumberOfAttempts,
                    xs: 6,
                    type: 'number',
                    maxLength: '10',
                    width: '55.1%',
                    labelWidth: '43.2%',
                    borderBottom: '0',
                    borderTop: '0',
                    height: '1.38rem',
                    margin: '0 2px 0 2px',
                }] : [{
                    key: 'Nodata6',
                    label: '',
                    xs: 6,
                    isLabel: true
                }]),
                {
                    key: 'F85TestResultLabel',
                    label: 'Test Result',
                    xs: 2,
                    isLabel: true,
                    labelWidth: '96%',
                    textAlign: 'end',
                    fontSize: '9pt',
                    fontWeight: '600',
                    padding: '5px 0 0 0'
                },
                {
                    key: 'F85TestResult',
                    value: TestAsFoundResultValue(formData) ? '' : formData.F85TestResult,
                    isRequired: true,
                    isDropDown: true,
                    placeholder: 'Select Test Result',
                    options: TestResultDropdownOptions(formData),
                    xs: 4,
                    labelWidth: '0',
                    width: '100%',
                    borderTop: '0',
                    borderBottom: isFailResult(formData) ? '0' : ''
                }
            ]
        },
        {
            key: 3,
            fields: [
                ...(includeP716(formName) ? [{
                    key: 'F1074PermutationObserved',
                    label: 'Permutation Observed',
                    value: formData.F1074PermutationObserved,
                    isDropDown: true,
                    placeholder: 'Select Permutation Observed',
                    options: [
                        { name: 'Select Permutation Observed', value: '' },
                        { name: 'High Load Factor Exceeded', value: 'High Load Factor Exceeded' },
                        { name: 'Time Exceeded', value: 'Time Exceeded' },
                        { name: 'Valve Overshoot', value: 'Valve Overshoot' },
                        { name: 'Valve Spool Stuck Detected', value: 'Valve Spool Stuck Detected' },
                        { name: 'Other, Please Specify in Notes', value: 'Other, Please Specify in Notes' },
                    ],
                    xs: 6,
                    width: '56.4%',
                    labelWidth: '43.2%',
                    height: '1.7rem',
                }] : [{
                    key: 'Nodata7',
                    label: '',
                    xs: 6,
                    isLabel: true
                }]),
                {
                    key: 'FailedComponents',
                    label: 'Failed Components',
                    xs: 2,
                    fontWeight: '600',
                    isLabel: true,
                    padding: '5px 0 0 0',
                    labelWidth: '96%',
                    textAlign: 'end',
                    fontSize: '9pt',
                },
                {
                    key: 'F348FailedComponents',
                    label: '',
                    value: isFailResult(formData) ? formData.F348FailedComponents : '',
                    placeholder: FailedComponent.SEARCH_FAILED_COMPONENTS,
                    isRequired: isFailResult(formData),
                    isDisabled: isFailedDisabled(formData),
                    readOnly: isFailedDisabled(formData),
                    isFailedDropDown: isFailResult(formData),
                    options: failedComponentsOptions,
                    xs: 2,
                    fontSize: '8.4pt',
                    labelWidth: '0',
                    width: '100%',
                    borderTop: '0',
                    paddingLeft: '1px',
                    height: failedComponentsHeight(formData)
                },
                {
                    key: 'F349FailedComponents1',
                    value: isFailResult(formData) ? formData.F349FailedComponents1 : '',
                    placeholder: FailedComponent.SEARCH_FAILED_COMPONENTS,
                    isDisabled: isFailedDisabled(formData),
                    readOnly: isFailedDisabled(formData),
                    isFailedDropDown: isFailResult(formData),
                    options: failedComponentsOptions,
                    xs: 2,
                    labelWidth: '0',
                    width: '100%',
                    fontSize: '8.4pt',
                    borderTop: '0',
                    borderLeft: '0',
                    paddingLeft: '1px',
                    height: failedComponentsHeight(formData)
                }
            ]
        },
        {
            key: 4,
            fields: [
                {
                    key: 'Nodata7',
                    label: '',
                    xs: 8,
                    isLabel: true
                },
                {
                    key: 'remark',
                    label: 'Remark: Record manufacturer and model of failed components on the TRF.',
                    isLabel: true,
                    xs: 4,
                    fontWeight: '600',
                    labelWidth: '100%',
                    fontSize: '8.5pt',
                    color: '#ea7c34'
                }]
        },
    ]
});
